import React from 'react';
import { Card, CardContent, CardDescription, CardHeader, CardTitle } from './ui/card';
import { Table, TableBody, TableCell, TableHead, TableHeader, TableRow } from './ui/table';
import { Thermometer, Clock, Settings, Mail } from 'lucide-react';

const WarmUpPage = () => {
  const warmupPhases = [
    {
      phase: "Phase 1: Initial Trust Building (Week 1)",
      whoToSendTo: "Only your most active and engaged contacts",
      volume: "10–20 emails per day",
      goal: "Generate opens, clicks, and replies",
      tips: "Personalize emails and encourage replies"
    },
    {
      phase: "Phase 2: Gradual Expansion (Weeks 2–3)",
      whoToSendTo: "Broaden to moderately engaged contacts",
      volume: "Double your volume each week (e.g., 20 → 40 → 80)",
      goal: "Maintain strong engagement while scaling",
      tips: "Watch for bounce rate spikes or spam complaints"
    },
    {
      phase: "Phase 3: Scaling to Full Volume (Week 4+)",
      whoToSendTo: "Your full intended audience (avoid risky/inactive emails)",
      volume: "Ramp up to target daily volume (10-20% growth per day)",
      goal: "Sustain reputation at normal sending levels",
      tips: "Continuously monitor engagement, sender score, and deliverability"
    }
  ];

  return (
    <div className="min-h-screen bg-gradient-to-br from-slate-50 to-slate-100 p-6">
      <div className="max-w-7xl mx-auto">
        <div className="text-center mb-8">
          <div className="flex items-center justify-center mb-4">
            <Thermometer className="w-8 h-8 text-orange-600 mr-3" />
            <h1 className="text-4xl font-bold text-slate-800">WarmUp</h1>
          </div>
          <p className="text-slate-600 text-lg">Email warming and reputation management</p>
        </div>

        {/* WarmUp Phases Table */}
        <Card className="border-0 shadow-lg bg-white/80 backdrop-blur-sm mb-8">
          <CardHeader>
            <CardTitle className="flex items-center text-slate-700 text-2xl">
              <Mail className="w-6 h-6 mr-2 text-orange-600" />
              Email WarmUp Phases
            </CardTitle>
            <CardDescription className="text-lg">
              Strategic approach to building email reputation and deliverability
            </CardDescription>
          </CardHeader>
          <CardContent>
            <div className="overflow-x-auto">
              <Table>
                <TableHeader>
                  <TableRow className="bg-slate-50">
                    <TableHead className="font-bold text-slate-700 w-[200px]">Phase</TableHead>
                    <TableHead className="font-bold text-slate-700 w-[250px]">Who to Send To</TableHead>
                    <TableHead className="font-bold text-slate-700 w-[200px]">Volume</TableHead>
                    <TableHead className="font-bold text-slate-700 w-[200px]">Goal</TableHead>
                    <TableHead className="font-bold text-slate-700">Tips / Watchpoints</TableHead>
                  </TableRow>
                </TableHeader>
                <TableBody>
                  {warmupPhases.map((phase, index) => (
                    <TableRow key={index} className="hover:bg-slate-50/50 transition-colors">
                      <TableCell className="font-medium text-slate-800 align-top">
                        {phase.phase}
                      </TableCell>
                      <TableCell className="text-slate-700 align-top">
                        {phase.whoToSendTo}
                      </TableCell>
                      <TableCell className="text-slate-700 align-top">
                        {phase.volume}
                      </TableCell>
                      <TableCell className="text-slate-700 align-top">
                        {phase.goal}
                      </TableCell>
                      <TableCell className="text-slate-700 align-top">
                        {phase.tips}
                      </TableCell>
                    </TableRow>
                  ))}
                </TableBody>
              </Table>
            </div>
          </CardContent>
        </Card>
      </div>
    </div>
  );
};

export default WarmUpPage;